import axios from 'axios';
import getCoordinates from '../components/utils/getCoodinates';

export async function login(email, password) {
    try {
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
            { email, password },
            { withCredentials: true, validateStatus: () => true }
        );
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}

export async function register(email, password, firstname, name, number, check, address, company) {
    const role = check ? "client" : "trader";
    let coords = null;

    if (role === 'trader')
        coords = await getCoordinates(address);

    try {
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
            {email, password, firstname, name, number, address, company, role, location: coords},
            { withCredentials: true, validateStatus: () => true }
        );
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}

export async function logout() {
    localStorage.removeItem('user');

    try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`,
            null,
            { withCredentials: true }
        );
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}